import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26bf4835"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-input" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "checkbox-original",
  type: "checkbox"
}, null, -1))
const _hoisted_3 = { class: "checkbox-label" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    value: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleChange = (e: Event) => {
  if (props.disabled) return
  emit('update:value', (e.target as HTMLInputElement).checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["checkbox", {
      'checked': _ctx.value,
      'disabled': _ctx.disabled,
    }]),
    onChange: _cache[0] || (_cache[0] = $event => handleChange($event))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 34))
}
}

})